import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tab-content flex-n" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "zw-label" }

import {computed} from "vue";

type TabList={
  label:string,
  value:string|number
}
interface Props{
  list:TabList[],
  modelValue:number|string
}



export default /*@__PURE__*/_defineComponent({
  __name: 'TabContent',
  props: {
    list: { default: ()=>{
    return []
  } },
    modelValue: { default: '' }
  },
  emits: ["getAllData", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props=__props

//todo 向外抛值
const emit = __emit;
const sValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
});

const chooseTab=(value:string|number)=>{
  console.log(value)
  emit("update:modelValue", value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(sValue.value==item.value?'choose':''),
        onClick: ($event: any) => (chooseTab(item.value)),
        key: item.value
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "choose-line" }, null, -1)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.label), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})